<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild" v-if="!$route.meta.hideTitle">
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo.png" />
      </div>
      <div class="nav-right">
        <!-- 导航内容 -->
        <ul class="header-nav-wrapper">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active ' : ''"
            @click="navClick(index, item.name, item)"
          >
            <a
              :to="!item.path ? '' : item.path"
              :href="!item.path ? '' : item.path"
            >
              <!-- <a :to="!item.path?'':item.path" :href="!item.path?'':item.path"> -->
              {{ item.name }}
              <span
                v-if="item.children.length > 0"
                class="glyphicon glyphicon-menu-down"
              ></span>
              <i class="underline"></i>
              <!-- </a> -->
            </a>
            <div class="dl" v-if="item.children.length > 0">
              <div class="left-content">
                <div
                  :label="i.name"
                  v-for="(i, n) in item.children"
                  :key="n"
                  class="dt"
                  :class="
                    (n == 0 && $route.name == 'ourFocus') ||
                    (n == 1 && $route.name == 'ourFocus1')
                      ? 'active'
                      : ''
                  "
                  @click="toDetail(n)"
                  @mouseenter="activeName = n"
                >
                  {{ i.name }}
                </div>
              </div>
              <!-- <div class="right-content" v-if="activeName==0">
                <div>
                  <img src="@/assets/img/types.png" alt="">{{ $t('service.typeTitle3')}}
                </div>
                <div>
                  <img src="@/assets/img/types.png" alt=""> {{ $t('service.typeTitle4')}}
                </div>
                <div>
                  <img src="@/assets/img/types.png" alt=""> {{ $t('service.typeTitle5')}}
                </div>
              </div>
              <div class="right-content" v-if="activeName==1">
                <div>
                  <img src="@/assets/img/types.png" alt=""> {{ $t('service.typeTitle5')}}
                </div>
                <div>
                  <img src="@/assets/img/types.png" alt=""> {{ $t('service.typeTitle6')}}
                </div>
              </div> -->
            </div>
          </li>
        </ul>
        <lang-select class="right-menu-item hover-effect" />
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="@/assets/img/logo.png" alt="logo" />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <span
          class="glyphicon glyphicon-list"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
          style="font-size: 20px; margin-right: 10px"
        ></span>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
          >
            <!-- <a
              :to="!item.path?'':item.path"
              :href="!item.path?'':item.path"
              v-if="item.children && item.children.length==0"
            >-->
            <router-link
              :to="!item.path ? '' : item.path"
              data-toggle="collapse"
              data-target="#menu"
              v-if="item.children && item.children.length == 0"
            >
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
            <!-- </a> -->
            <div v-else class="more-list">
              <a
                class="nav-link dropdown-toggle"
                data-toggle="collapse"
                :data-target="'#multiCollapseExample' + index"
                role="button"
                aria-expanded="false"
                :aria-controls="'multiCollapseExample' + index"
                style="color: #000"
                >{{ item.name }}</a
              >
              <ul
                class="collapse multi-collapse"
                :id="'multiCollapseExample' + index"
                style="padding-left: 1rem"
              >
                <li v-for="(i, index2) in item.children" :key="index2">
                  <a
                    :to="!i.path ? '' : i.path"
                    :href="!i.path ? '' : i.path"
                    v-if="i.path"
                    >{{ i.name }}</a
                  >
                  <router-link
                    :target="i.newPage ? '_blank' : ''"
                    :to="i.path"
                    v-else
                    >{{ i.name }}</router-link
                  >
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div
      style="position: relative; height: 360px; width: 100%"
      class="banner"
      v-if="!$route.meta.hideBottom"
    >
      <div v-if="$route.name == 'home'" style="width: 100%; height: 100%">
        <img
          src="../assets/img/banner5.png"
          style="width: 100%; height: 100%"
          alt
        />
      </div>
      <img
        v-if="$route.name == 'aboutus'"
        src="../assets/img/banner4.png"
        style="width: 100%; height: 100%"
        alt
      />
      <img
        v-if="$route.name == 'newsinformation'"
        src="../assets/img/banner2.png"
        style="width: 100%; height: 100%"
        alt
      />
      <img
        v-if="$route.name == 'contactus'"
        src="../assets/img/banner3.png"
        style="width: 100%; height: 100%"
        alt
      />
      <div v-if="$route.name == 'home'" class="slogan">
        <p>深耕墨西哥市场</p>
        <p>提供全方位的物流解决方案</p>
        <p>Provide comprehensive logistics solutions</p>
      </div>
      <div
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0px;
          left: 0px;
        "
      ></div>
    </div>
  </div>
</template>
<script>
import LangSelect from "@/components/LangSelect";
export default {
  components: {
    LangSelect,
    // Search
  },

  name: "Header",
  data() {
    return {
      pageName: "",
      carouselHeight: 0,
      activeName: "0",
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: this.$t("navbar.dashboard1"),
          path: "/home",
          children: [],
        },
        {
          name: this.$t("navbar.nav1"),
          path: "/aboutUs",
          children: [],
        },
        {
          name: this.$t("navbar.dashboard"),
          path: "/",
          children: [
            {
              name: this.$t("service.type1"),
              path: "/ourFocus",
            },
            {
              name: this.$t("service.type2"),
              path: "/ourFocus1",
            },
          ],
        },
        {
          name: this.$t("navbar.nav2"),
          path: "/newsinformation",
          children: [],
        },
        {
          name: this.$t("navbar.nav3"),
          path: "/searchPage",
          children: [],
        },
        // {
        //   name: this.$t("navbar.nav4"),
        //   path: "",
        //   children: [
        //     {
        //       name: this.$t("service.type1"),
        //       path: "/ourFocus"
        //     },
        //     {
        //       name: this.$t("service.type2"),
        //       path: ""
        //     }
        //   ]
        // },
        {
          name: this.$t("navbar.nav5"),
          path: "/ContactUs",
          children: [],
        },
      ],
    };
  },
  created() {
    this.carouselHeight = (document.body.clientWidth * 240) / 1920 - 10 + "px";
    document.title = this.$t("commen.pageTitle");
    if (window.location.href.indexOf("searchPage") > -1) {
      this.pageName = "searchPage";
    }
    window.addEventListener("scroll", function () {
      var scrollHeight = window.scrollY;
      if (scrollHeight > 80) {
        document.querySelector(".header-nav").classList.add("c-head-move");
      } else {
        document.querySelector(".header-nav").classList.remove("c-head-move");
      }
    });
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab;
    },
    toDetail(n) {
      this.activeName = n;
      if (n == 0) {
        location.href = "/ourFocus";
      } else {
        location.href = "/ourFocus1";
      }
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);

      this.menuName = name;

      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
  },
};
</script>
<style scoped>
/* 顶部 */

#header {
  transition: all ease 0.6s;
  position: relative;
  background-color: #fff;
  padding-top: 80px;
}

.slogan {
  background: rgb(0, 0, 0);
  opacity: 0.42;
  /* width: 30%; */
  padding: 20px;
  position: absolute;
  top: 80px;
  color: #fff;
  right: 0px;
  z-index: 99;
}
.slogan p {
  width: 500px;
  font-size: 26px;
  text-align: justify;
  word-break: break-all;
  text-align-last: justify;
}
.slogan p:first-child {
  font-size: 40px;
  font-weight: 700;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
}
.show-photo {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 284px;
  overflow: hidden;
}
.show-photo img {
  width: 450px;
}
.nav-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.right-menu-item {
  margin-left: 80px;
}
/* 顶部的图标 */

#header .header-top span {
  margin: 0 8px;
}

/* 导航栏 */
#header .header-nav.c-head-move {
  top: -80px;
}
#header .header-nav {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 999;
  padding: 0px;
  position: fixed;
  width: 100%;
  background-color: #fff;
  padding-left: 5%;
  top: 0px;
  transition: all 0.8s ease 0s;
  z-index: 999;
}

/* 导航栏logo */

#header .header-nav .header-nav-logo {
  width: 170px;
  position: relative;
}

/* 导航栏logo图片 */

#header .header-nav .header-nav-logo img {
  width: 170px;
}

/* 导航栏 导航容器 */

#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}

#header .header-nav .header-nav-wrapper {
  line-height: 80px;
  margin: 0;
  display: flex;
  align-items: flex-end;
}

/* 导航栏 每个导航 */

#header .header-nav .header-nav-wrapper > li {
  float: left;
  padding: 0 20px;
  /* width: 80px; */
  text-align: center;
  position: relative;
}

/* 导航栏 每个导航下面的 a 链接 */

#header .header-nav .header-nav-wrapper > li > a {
  color: #000000;
  font-size: 15px;
  position: relative;
  font-weight: 300;
  display: inline-block;
  height: 78px;
  line-height: 78px;
}

/* 导航栏 每个导航下面的 a 链接的下划线 */

#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #ffffff;
}

/* 导航栏 每个导航下面的 a 链接的右侧小三角 */

#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */

#header .header-nav .header-nav-wrapper > li > a:hover {
  text-decoration: none;
  color: #f18700;
  font-weight: 700;
}

/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */

#header .header-nav .header-nav-wrapper > li > a:hover span {
  /* transform: rotate(180deg); */
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */

#header .header-nav .header-nav-wrapper > li.active > a {
  color: #f18700;
  text-decoration: none;
  font-weight: bold;
  border-bottom: 2px solid #f18700;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li:hover .dl {
  display: flex;
  visibility: visible;
  align-content: center;
  justify-content: center;
  opacity: 1;
}
.dl .left-content {
  width: 450px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* border-right: 1px solid #dcdcdc; */
}
.dl .left-content .dt {
  width: 300px;
  position: relative;
  display: block;
  padding: 10px 30px;
  line-height: 20px;
  cursor: pointer;
  font-size: 18px;
  border-radius: 50px;
  color: #333;
  margin-bottom: 30px;
  text-align: center;
}
.dl .left-content .dt.active,
.dl .left-content .dt:hover {
  background-color: #f18700;
  color: #ffffff;
}
.right-content {
  padding-left: 20px;
}
.right-content div {
  display: flex;
  align-items: center;
  font-size: 16px;
  border-bottom: 1px solid #dddddd;
}
.right-content div img {
  width: 30px;
  margin-right: 40px;
}
#header .header-nav .header-nav-wrapper > li > .dl {
  z-index: 9;
  position: fixed;
  left: 0;
  top: 76px;
  right: 0;
  z-index: 999999;
  padding: 50px 0;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s all;
  background-color: #fff;
  border-top: 1px solid #f1f1f1;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 */

#header .header-nav .header-nav-wrapper > li > .dl > .dt {
  width: 100%;
  color: #666;
}

#header .header-nav .header-nav-wrapper > li > .dl > .dt > a {
  /* color: rgb(180, 13, 13); */
  color: #333;
  display: inline-block;
  width: 100%;
  /* font-weight: bold; */
  padding: 10px;
}

/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/

#header .header-nav .header-nav-wrapper > li > .dl > .dt > a:hover {
  text-decoration: none;
  /* color: #fff; */
}

@keyframes slide-in {
  0% {
    /* opacity: 0; */
    top: 60%;
  }
  100% {
    /* opacity: 1; */
    top: 72%;
  }
}

#header .header-nav .header-nav-wrapper > li > .dl > .dt:hover {
  cursor: pointer;
}

@media screen and (max-width: 997px) {
  #heade,
  .header-nav {
    width: 100%;
  }
  #header {
    padding-top: 10px;
  }
  .banner {
    height: 200px !important;
    display: none;
  }
  #header .header-nav-m {
    width: 100%;
    top: 0px;
    z-index: 999;
    box-sizing: border-box !important;
    height: 40px;
    flex-direction: row;
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
  }
  #header .header-nav-m .header-nav-m-logo {
    /* width: 195px; */
    padding-left: 1rem;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    font-size: 20px;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 40px;
    right: 0;
    width: 200px;
    background: #fff;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper li {
    line-height: 40px;
    border-bottom: 1px dashed #efefef;
    text-align: left;
    padding-left: 1rem;
  }

  #header .header-nav-m .header-nav-m-wrapper > li.active > a {
    color: #f18700;
    font-weight: 700;
  }
  .more-list #header .header-nav-m .header-nav-m-wrapper li:last-child {
    border: none;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper li a {
    font-size: 15px;
    /* font-weight: bold; */
    color: #000;
    padding: 15px 0;
    position: relative;
  }
  .more-list .dropdown-toggle::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue